// when we timeout reserved bookings
const SLOT_TIMEOUT_MINUTES = 30

const BOOKING_STATUS_RESERVED = 'reserved'
const BOOKING_STATUS_TIMEOUT = 'timeout'
const BOOKING_STATUS_CONFIRMED = 'confirmed'

module.exports = {
  SLOT_TIMEOUT_MINUTES,
  BOOKING_STATUS_RESERVED,
  BOOKING_STATUS_TIMEOUT,
  BOOKING_STATUS_CONFIRMED,
}